import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/wide-bay/$suburb")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing/hervey-bay", statusCode: 301 });
  },
});
